import loadable from '@loadable/component';
import loadableModule from '../../loadable-module';

const LinkPilesModule = loadableModule({
    LoadableComponent: loadable(() =>
        import(
            /* webpackChunkName: "linkpiles" */
            './LinkPiles'
        )
    ),
    componentName: 'LinkPiles',
    placeholder: {
        placeholderType: 'TitledBlock',
        size: 'md',
    },
});
export default LinkPilesModule;
